export default function secondsToMilliseconds(seconds: number): number {
  return seconds * 1_000;
}
